export default {
  path: 'winter-service/tasks',
  name: 'Tasks',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/TasksIndexView.vue')
}
